import {
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { BoardType, ParamsPanelProps } from 'Types';

import MaterialPatternInput from 'designer/MaterialPatternInput';
import MaterialSelector from 'designer/MaterialSelector';
import NumberInput from 'designer/NumberInput';
import Switch from 'designer/Switch';

function PlaidParamsPanel(props: ParamsPanelProps<BoardType.Plaid>) {
  const { params, onParamChange, units } = props;
  const {
    background,
    wood1,
    wood2,
    startOn,
    numCols,
    numRows,
    colWidth,
    rowHeight,
    hStripe,
    vStripe,
    isHStripeOn1,
    isHStripeOn2,
    isVStripeOn1,
    isVStripeOn2,
  } = params;

  return (
    <Grid container direction="column" spacing={4}>
      <Grid container item spacing={2} wrap="nowrap">
        <Grid item flexShrink={0}>
          <FormControl variant="standard">
            <InputLabel>Background</InputLabel>
            <MaterialSelector
              onChange={onParamChange('background')}
              value={background}
            />
          </FormControl>
        </Grid>
        <Grid item flexShrink={0}>
          <FormControl variant="standard">
            <InputLabel>Wood 1</InputLabel>
            <MaterialSelector onChange={onParamChange('wood1')} value={wood1} />
          </FormControl>
        </Grid>
        <Grid item flexShrink={0}>
          <FormControl variant="standard">
            <InputLabel>Wood 2</InputLabel>
            <MaterialSelector onChange={onParamChange('wood2')} value={wood2} />
          </FormControl>
        </Grid>
        <Grid item flexGrow={1} flexShrink={1} maxWidth={400}>
          <FormControl fullWidth variant="standard">
            <InputLabel>Start On</InputLabel>
            <Select
              fullWidth
              value={startOn}
              onChange={(event) =>
                onParamChange('startOn')(event.target.value as typeof startOn)
              }
            >
              <MenuItem key="background" value="background">
                Background
              </MenuItem>
              <MenuItem key="wood1 A" value="wood1/background">
                Wood 1/Background
              </MenuItem>
              <MenuItem key="wood1 B" value="wood1/wood2">
                Wood 1/Wood 2
              </MenuItem>
              <MenuItem key="wood2" value="wood2">
                Wood 2
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container item spacing={2} wrap="nowrap">
        <Grid item xs={3}>
          <NumberInput
            label="Row Height"
            step={1 / 8}
            value={rowHeight}
            onChange={onParamChange('rowHeight')}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            label="Num Rows"
            value={numRows}
            onChange={onParamChange('numRows')}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            label="Column Width"
            step={1 / 8}
            value={colWidth}
            onChange={onParamChange('colWidth')}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            label="Num Columns"
            value={numCols}
            onChange={onParamChange('numCols')}
          />
        </Grid>
      </Grid>

      <Grid container item spacing={2} wrap="nowrap">
        <Grid item flexGrow={1}>
          <MaterialPatternInput
            label="Horizontal Stripe"
            onChange={onParamChange('hStripe')}
            onSelectionChange={() => {}}
            previewHeight={0}
            selection={null}
            units={units}
            value={hStripe}
          ></MaterialPatternInput>
        </Grid>
        <Grid item>
          <FormControlLabel
            sx={{ mr: 0, whiteSpace: 'nowrap' }}
            control={
              <Switch
                onChange={onParamChange('isHStripeOn1')}
                value={isHStripeOn1}
              />
            }
            label="On Wood 1"
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            sx={{ mr: 0, whiteSpace: 'nowrap' }}
            control={
              <Switch
                onChange={onParamChange('isHStripeOn2')}
                value={isHStripeOn2}
              />
            }
            label="On Wood 2"
          />
        </Grid>
      </Grid>

      <Grid container item spacing={2} wrap="nowrap">
        <Grid item flexGrow={1}>
          <MaterialPatternInput
            label="Vertical Stripe"
            onChange={onParamChange('vStripe')}
            onSelectionChange={() => {}}
            previewHeight={0}
            selection={null}
            units={units}
            value={vStripe}
          ></MaterialPatternInput>
        </Grid>
        <Grid item>
          <FormControlLabel
            sx={{ mr: 0, whiteSpace: 'nowrap' }}
            control={
              <Switch
                onChange={onParamChange('isVStripeOn1')}
                value={isVStripeOn1}
              />
            }
            label="On Wood 1"
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            sx={{ mr: 0, whiteSpace: 'nowrap' }}
            control={
              <Switch
                onChange={onParamChange('isVStripeOn2')}
                value={isVStripeOn2}
              />
            }
            label="On Wood 2"
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PlaidParamsPanel;
